module.exports = __webpack_public_path__ + "media/bootstrap-icons/upc-b6e2ee20.svg";